<div class="flight-info">
    <mat-icon *ngIf="flightIconName"
              svgIcon="{{ flightIconName }}"></mat-icon>
    <app-time-counter [timeType]="timeType" [timeString]="timeString"></app-time-counter>
</div>
